<template>
  <section class="gt-page">
    <div class="gt-page-inner compact">
      <div class="gt-card onboarding">
        <span class="gt-pill">Configuracion inicial</span>
        <h1>Deja listo el modulo base</h1>
        <p class="gt-muted">Este flujo se deja preparado para crecer: empresa, sucursal, modulos y permisos.</p>

        <div class="steps">
          <label v-for="step in steps" :key="step.key" class="step">
            <input type="checkbox" v-model="completed" :value="step.key" />
            <span>
              <strong>{{ step.title }}</strong>
              <small>{{ step.description }}</small>
            </span>
          </label>
        </div>

        <button class="gt-button primary" :disabled="loading || !companyToken" @click="complete">
          {{ loading ? 'Guardando...' : 'Marcar configuracion como completada' }}
        </button>
        <p v-if="message" class="message">{{ message }}</p>
        <p v-if="error" class="error">{{ error }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'OnboardingView',
  data() {
    return {
      loading: false,
      message: '',
      error: '',
      completed: ['company_profile', 'branch_profile', 'modules_review'],
      steps: [
        { key: 'company_profile', title: 'Datos de empresa', description: 'Nombre comercial, RFC y contacto.' },
        { key: 'branch_profile', title: 'Sucursal inicial', description: 'Datos basicos de la matriz.' },
        { key: 'modules_review', title: 'Revision de modulos', description: 'Confirmar modulos activos y limites.' },
      ],
    };
  },
  computed: {
    companyToken() { return this.$store.state.context?.company?.token; },
  },
  methods: {
    async complete() {
      this.loading = true;
      this.error = '';
      try {
        const { data } = await api.post('/api/setup/onboarding/complete', {
          company_token: this.companyToken,
          completed_steps: this.completed,
        });
        this.message = data.message;
        await this.$store.dispatch('initializeApp');
        this.$router.push('/dashboard');
      } catch (error) {
        this.error = error.response?.data?.error || 'No se pudo completar la configuracion.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.compact { max-width: 780px; }
.onboarding { padding: 2rem; }
h1 { font-size: 2.35rem; margin: .8rem 0 .35rem; }
.steps { display: grid; gap: .85rem; margin: 1.5rem 0; }
.step { display: flex; gap: .85rem; border: 1px solid var(--gt-border); background: #fff; padding: 1rem; border-radius: 18px; }
.step input { width: 1.2rem; }
.step strong { display: block; }
.step small { color: var(--gt-muted); }
.message { color: var(--gt-success); font-weight: 800; }
.error { color: var(--gt-danger); font-weight: 800; }
</style>
